angular.module('unergie.main')
.controller('sendInBlueMailsCtrl', ($scope, $state, DataAccess, DataAccessSearch, TableGeneratorService, XmlParser, AlertManager, ApiAdmin, DownloadService, ApiContentSearch, ErrorCatcher) => {
    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    $scope.mails = {
        refreshing: false,
        show: {},
        columns: {
            _id: { label: 'ID', mode: 'hidden' },
            callPayload: { label: 'callPayload', mode: 'hidden' },
            mail: { label: 'Email', mode: 'search_wildcard' },
            createdAt: { label: 'Date', mode: 'search_date' },
            campaign_name: { label: 'Nom campagne', mode: 'search_wildcard' },
            attachments: { label: 'Pièces jointes', mode: 'search_strict' },
            click: { label: 'Clické', mode: 'search_strict' },
            opened: { label: 'Lu', mode: 'search_strict' },
            invalid_email: { label: 'Email invalide', mode: 'search_strict' },
            hard_bounce: { label: 'Hard bounce', mode: 'search_strict' },
            delivered: { label: 'Délivré', mode: 'search_strict' },
            blocked: { label: 'Bloqué', mode: 'search_strict' },
            error: { label: 'Erreur', mode: 'search_strict' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.mails, 'client-contacts-campaign', null, null, { orderBy: '-createdAt' }, ApiContentSearch)

    $scope.getAttachmentName = (attachment) => {
        return attachment && (attachment.name || (attachment.key && attachment.key.split('/').pop()) || (attachment.url && attachment.url.split('/').pop()))
    }

    $scope.getAttachmentHref = (email, attachment) => {
        if (!attachment) {
            return
        }
        if (attachment.url && attachment.url.startsWith('http')) {
            return attachment.url
        }
        return `/api-user/campaign-email/${email._id}/attachment/${attachment._id}`
    }

    $scope.reSendEmail = (mail) => {
        mail.sendingEmail = true
        return ApiAdmin.reSendTemplatedEmail({ id: mail._id }, {}).$promise.then(() => {
            AlertManager.success('Renvoi OK')
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            mail.sendingEmail = false
        })
    }

    $scope.refresh()
})
